// ============================================================================
// Form Config: CustomProperties
// Key: customProperties
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { RequiredStringSchema } from '@/shared/forms/utility/validators'
// #endregion

// #region Create Form
export const customPropertiesCreateFormConfig: FormSection[] = [
	{
		title: 'forms_custom_properties_create_section_main',
		fields: [
			{
				name: 'key',
				label: 'forms_custom_properties_create_key',
				type: 'text' as const,
				validator: RequiredStringSchema(),
				initialValue: '',
			},
			{
				name: 'keyDisplayName',
				label: 'forms_custom_properties_create_key_display_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'sortOrder',
				label: 'forms_custom_properties_create_sort_order',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'hidden',
				label: 'forms_custom_properties_create_hidden',
				type: 'checkbox' as const,
				initialValue: false,
			},
		],
	},
]
// #endregion

// #region Edit Form
export const customPropertiesEditFormConfig: FormSection[] = [
	{
		title: 'forms_custom_properties_edit_section_main',
		fields: [
			{
				name: 'sortOrder',
				label: 'forms_custom_properties_edit_sort_order',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'hidden',
				label: 'forms_custom_properties_edit_hidden',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'key',
				label: 'forms_custom_properties_edit_key',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'keyDisplayName',
				label: 'forms_custom_properties_edit_key_display_name',
				type: 'text' as const,
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const customPropertiesFormsConfig = {
	create: customPropertiesCreateFormConfig,
	edit: customPropertiesEditFormConfig,
} as const
// #endregion
